export default __webpack_public_path__ + "locales/pt/DeleteSelfProfileDialog.json?hash=be6946a289c58a17f0a8ca1d9d33a69c";